import React from "react";

export default function SQL_Views() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Views</h1>
      <p>This is the SQL_Views component generated from the SQL JSON.</p>
    </div>
  );
}
